import { type FC } from "react";

import { AssessmentProgressBar } from "components/footer/AssessmentProgressBar";
import { InstructorMainFooter } from "components/footer/InstructorMainFooter";
import { RecordingAgentMainFooter } from "components/footer/RecordingAgentMainFooter";
import { StudentMainFooter } from "components/footer/StudentMainFooter";
import { useIsAssessing } from "components/materials/section/assessment/hooks";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId, selectIsRecordingAgent } from "store/selectors";

export const MainFooter: FC = () => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const isAssessing = useIsAssessing();
  const { canAuthorSection } = useCapabilities();
  const isRecordingAgent = useAppSelector(selectIsRecordingAgent);

  if (!sectionId) {
    return null;
  }

  if (isRecordingAgent) {
    return <RecordingAgentMainFooter />;
  }

  if (!canAuthorSection) {
    return <StudentMainFooter />;
  }

  if (isAssessing) {
    return <AssessmentProgressBar />;
  }

  return <InstructorMainFooter />;
};
